import axiosInstance from "../../translator";
import { notificationsApi } from "../../constants/apis/apiEndpoints";

export const fetchNotificationsList = async (urlParams) => {
  return axiosInstance
    .get(`${notificationsApi?.notificationsList}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const changeReadStatus = async (urlParams) => {
  return axiosInstance
    .patch(`${notificationsApi?.notificationsList}/${urlParams.id}`, { read_status: urlParams.read_status })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
